/**
 * Parameter zumr Erzeugen der EnvironmentConfig.
 * Mehr Felder optional als in EnvironmentConfig, denn dort greifen Defaults.
 */
export type EnvConfigParams = {
    production: boolean;
    gatewayUrl?: string;
    portalServiceName?: string;
    testUser?: string;
    testPassword?: string;
};

/**
 * Umgebungskonfiguration.
 */
export class EnvironmentConfig {

    /**
     * Die URL des Gateways. Wenn nicht angegeben, dann wird sie unter der gleichen Domain angenommen wie das Frontend.
     * Das ist bei uns i.d.R. immer der Fall außer im npm start Modus (DEV)
     */
    readonly gatewayUrl?: string;

    /**
     * False bedeutet lokale Frontend-Entwicklung mit npm start.
     * True verwenden wir immer dann, wenn das Frontend gebaut wird um es zusammen mit dem Backend des Microservice zu verpacken.
     * Außerdem wird dann auch der Produktiv-Modus von Angular aktiviert.
     */
    readonly production: boolean;

    /** Der Name des Services, der die SinglePage-Application bereitstellt.
     Wird benötigt, um mehrere verschiedene Portal-Services zu ermöglichen und
     in diesen korrekte base href sowie Endpunkt-URLs zu verwenden,
     sollte in anderen Services aber nicht verwendet werden. */
    readonly portalServiceName: string = 'portal';

    /**
     * Basic Auth username für development.
     */
    readonly testUser?: string;

    /**
     * Basic Auth password für development.
     */
    readonly testPassword?: string;

    /**
     * @param envConfigParams die Parameter für die Konfiguration. Falls nicht angegeben, wird auf Defaults für dev zurückgefallen.
     */
    constructor(envConfigParams?: EnvConfigParams) {
        if (envConfigParams) {
            this.production = envConfigParams.production
            this.gatewayUrl = envConfigParams.gatewayUrl;
            this.portalServiceName = envConfigParams.portalServiceName || 'portal';
            this.testUser = envConfigParams.testUser;
            this.testPassword = envConfigParams.testPassword;
        } else {
            // eslint-disable-next-line no-console
            console.warn('No environmentConfig set! Guessing some typical development values.');
            this.production = false;
            this.gatewayUrl = 'http://localhost:8080'
            // eslint-disable-next-line no-console
            console.dir(this);
        }
    }

    isDev() {
        return !this.production;
    }

    /**
     * Alles, was nicht "dev" ist, ist prod.
     */
    isProd() {
        return this.production;
    }

}

